var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.391,
    height: 20.175,
    viewBox: "0 0 18.391 20.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9819",
    "data-name": "Group 9819",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11312",
    "data-name": "Path 11312",
    d: "M463.726,369.267l1.749-1.164c1.009-.671,2.016-1.344,3.029-2.01a.275.275,0,0,0,.143-.294,3.638,3.638,0,1,1,.786,2.055l-.093-.114c-.122.079-.24.156-.358.235q-2.033,1.352-4.066,2.7a.236.236,0,0,0-.119.325,3.319,3.319,0,0,1-.005,2.029c-.032.1-.055.174.061.251q2.225,1.47,4.444,2.95a.209.209,0,0,0,.047.015c.116-.131.226-.273.354-.4a3.527,3.527,0,0,1,3.724-.914,3.483,3.483,0,0,1,2.5,2.922,3.669,3.669,0,1,1-7.269.984c-.027-.226,0-.458-.012-.686a.3.3,0,0,0-.091-.208q-2.377-1.592-4.762-3.171a.614.614,0,0,0-.074-.036,3.714,3.714,0,0,1-5.213-.307,3.673,3.673,0,0,1-.013-4.855A3.716,3.716,0,0,1,463.726,369.267Z",
    transform: "translate(-457.579 -361.915)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.abd42d293df24c33928bc57b29d32a78.svg";
export { ForwardRef as ReactComponent };